module.exports = __webpack_public_path__ + "img/pattern3.1110a1d.svg";